import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, mergeMap, catchError } from 'rxjs/operators';
import {
  Login,
  LoginSuccess,
  LoginError,
  ResetUserPassword,
  ResetUserPasswordError,
  ResetUserPasswordSuccess,
  RequestUserPassword,
  RequestUserPasswordError,
  RequestUserPasswordSuccess,
  ValidateToken,
  ValidateTokenError,
  ValidateTokenSuccess,
  LogoutUserSuccess,
  LogoutUserError,
  LogoutUser,
  AuthUser,
  AuthUserError,
  AuthUserSuccess,
} from '../actions/auth.actions';
import { AuthAction } from '../constants';
import { AuthService } from '../../auth/auth.service';
import { UserAuthService } from 'app/core/service';

@Injectable()
export class AuthEffects {

  authUser$ = createEffect(() =>
    this.actions$.pipe(ofType<AuthUser>(AuthAction.AuthUser),
      switchMap(action => this.userAuthService.serverAuth(action.data).pipe(
        mergeMap(data => of(new AuthUserSuccess(data))),
        catchError(result => of(new AuthUserError(result)))
      )))
  );

  validateToken$ = createEffect(() =>
    this.actions$.pipe(ofType<ValidateToken>(AuthAction.ValidateToken),
      switchMap(action => this.userAuthService.validateToken(action.data).pipe(
        mergeMap(data => of(new ValidateTokenSuccess(data))),
        catchError(result => of(new ValidateTokenError(result)))
      )))
  );

  resetPassword$ = createEffect(() =>
    this.actions$.pipe(ofType<ResetUserPassword>(AuthAction.ResetUserPassword),
      switchMap(action => this.userAuthService.resetPassword(action.data).pipe(
        mergeMap(() => of(new ResetUserPasswordSuccess())),
        catchError(result => of(new ResetUserPasswordError(result)))
      )))
  );

  requestPassword$ = createEffect(() =>
    this.actions$.pipe(ofType<RequestUserPassword>(AuthAction.RequestUserPassword),
      switchMap(action => this.userAuthService.requestPassword(action.data).pipe(
        mergeMap(() => of(new RequestUserPasswordSuccess())),
        catchError(result => of(new RequestUserPasswordError(result)))
      )))
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType<LogoutUser>(AuthAction.LogoutUser),
      switchMap(() => {
        this.authService.logoutUser();
        return of(new LogoutUserSuccess(''));
      }),
      catchError(error => of(new LogoutUserError(error)))
    )
  );

  constructor(
    private authService: AuthService,
    private userAuthService: UserAuthService,
    private actions$: Actions,
  ) { }

}
